var __assign = this && this.__assign || function () {
  __assign = Object.assign || function (t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
      s = arguments[i];

      for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
    }

    return t;
  };

  return __assign.apply(this, arguments);
};

import { useCallback, useRef, useState } from "react";
import { getTargetElement } from "./get-target-element";
import { TypeOf } from "./type-of";
import { useEventListener } from "./use-event-listener";
import { useMutationObserver } from "./use-mutation-observer";
import { useEffectWithTarget } from "./use-effect-with-target";

var sizeParser = function (size) {
  if (TypeOf.isNumber(size)) {
    return size;
  }

  if (TypeOf.isString(size)) {
    return parseInt(size.replace("px", ""));
  }

  return 0;
};
/**
 * useSize 获取元素宽高
 * 支持 静态/动态测量
 * @param {*} target 支持 React.MutableRefObject<T> | Element | () => Element
 * @returns 宽高对象
 */


var useSize = function (target) {
  var _a = useState({
    width: 0,
    height: 0
  }),
      size = _a[0],
      setSize = _a[1];

  var sizeRef = useRef(null);
  var getSize = useCallback(function () {
    var _a, _b;

    var el = getTargetElement(target);
    if (!el) return;
    var sz = getComputedStyle(el);
    var sizeValue = {
      width: sizeParser(sz.width),
      height: sizeParser(sz.height)
    };

    if (((_a = sizeRef.current) === null || _a === void 0 ? void 0 : _a.width) != sizeValue.width || ((_b = sizeRef.current) === null || _b === void 0 ? void 0 : _b.height) != sizeValue.height) {
      setSize(sizeValue);
      sizeRef.current = __assign({}, sizeValue);
    }
  }, [target]);
  useMutationObserver(function (mutationList) {
    for (var _i = 0, mutationList_1 = mutationList; _i < mutationList_1.length; _i++) {
      var mutation = mutationList_1[_i];

      if (mutation.type === "attributes") {
        getSize();
      }
    }
  }, target, {
    attributes: true,
    subtree: true
  });
  useEventListener("resize", getSize, {
    target: window
  });
  useEffectWithTarget(function () {
    target && getSize();
  }, [], target);
  return size;
};

export { useSize };